/* eslint-disable no-unused-vars */
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import {
  Buttons,
  ApplicationsList,
  Loader,
  AddNewAppBtn,
  ErrorComponent,
  WelcomeManageApps,
} from 'components';
import * as S from './ManageApps.styled';
import { Info, AdvancedSettings, Book } from 'assets/icons';
import { manageAppsAPI } from 'services/manageApps.service';
import { addFieldStatus } from 'utils';
import { routes } from 'config';
import { isAdvertiserRole } from 'store/selectors';

const sortedAppListByPba_number = (appList) => {
  if (!appList) return undefined;
  if (appList && Array.isArray(appList) && appList.length > 0) {
    return [...appList]?.sort((a, b) => {
      const numberA = a.pba_number;
      const numberB = b.pba_number;
      if (numberA > numberB) {
        return -1;
      }
      if (numberA < numberB) {
        return 1;
      }
      return 0;
    });
  }
};

export default function ManageApps() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const isAdvertiser = useSelector(isAdvertiserRole);

  const { appList, isError, isSuccess, isLoading } = manageAppsAPI.useGetAppsListQuery('', {
    selectFromResult: (response) => {
      return {
        appList: sortedAppListByPba_number(response.data),
        isError: response.isError,
        isSuccess: response.isSuccess,
        isLoading: response.isLoading,
      };
    },
    refetchOnMountOrArgChange: true, // ✅ יבצע בקשה מחדש בכל כניסה לדף
  });

  const goToAdvancedSettings = () => {
    const link = routes.list.find((route) => route.id === 'manageApps/excludeSettings').url;
    navigate(link);
  };

  if (isLoading && !appList) return <Loader.Global delay={100} />;
  if (isError) return <ErrorComponent />;

  return (
    <>
      <S.Container>
        <S.Header>
          <h1>{t('apps.title')}</h1>
          <S.Wrap>
            <Buttons.TertiaryNormal
              id='Integrations_Guide'
              name='Integrations Guide'
              icon={<Book />}
              onClick={() => {
                window.open('https://developers.appnext.com/', '_blank');
              }}
            >
              Integrations Guide
            </Buttons.TertiaryNormal>
            {/* <Buttons.TertiaryNormal
              id='Advanced_Settings'
               name='Advanced Settings'
              icon={<AdvancedSettings />}
              onClick={goToAdvancedSettings}
              isDisabled={true}
            >
              Advanced Settings
            </Buttons.TertiaryNormal>
            */}
            <AddNewAppBtn.ManageAppsPage />
          </S.Wrap>
        </S.Header>
        {appList?.length ? <ApplicationsList appList={appList} /> : null}
        {!appList && !isLoading ? <WelcomeManageApps isAdvertiser={isAdvertiser} /> : null}
      </S.Container>
    </>
  );
}
